module.exports = __webpack_public_path__ + "static/media/DSC_0753.a38b7bba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0753.jpg
// module id = 602
// module chunks = 0